import restService from "../rest-service/RestService";
import OfflineDataService from "../offline-data-service/OfflineDataService";
import { IUserActivityLogItem } from "./Models";

const UserActivityLogService = {

    logUserActivity: async function (
        customerID: number,
        logItem: IUserActivityLogItem,
        offline: boolean,
        signal?: AbortSignal
    ): Promise<void> {
        if (!offline) {

            const path: string = "useractivitylog";
            await restService.post<IUserActivityLogItem, void>(path, logItem, signal);
   
        } else {
            await OfflineDataService.saveUserActivities(customerID, [logItem]);
        }

    },

    // This is for offline data support    
    logUserActivities: async function (
        customerID: number,
        logItems: Array<IUserActivityLogItem>,
        offline: boolean,
        signal?: AbortSignal
    ): Promise<void> {

        if (!offline) {

            const path: string = "useractivitylogs";
            await restService.post<Array<IUserActivityLogItem>, Array<IUserActivityLogItem>>(path, logItems, signal);

        } else {
            await OfflineDataService.saveUserActivities(customerID, logItems);
        }
    }
};

export default UserActivityLogService;